<app-loader></app-loader>
<router-outlet></router-outlet>

<ngx-spinner name="spinnerDownloadFile" bdOpacity="1" bdColor="rgba(255, 165, 0, 0.78)" size="large" color="#ffffff"
    align="center" type="ball-running-dots" [fullScreen]="true">
    <p style="color: #ffffff; text-align: center"><br><br>Download File...</p>
</ngx-spinner>

<ngx-spinner name="spinnerProsesCetak" bdOpacity="1" bdColor="rgba(255, 165, 0, 0.78)" size="large" color="#ffffff"
    align="center" type="ball-running-dots" [fullScreen]="true">
    <p style="color: #ffffff; text-align: center"><br><br>Proses Cetak...</p>
</ngx-spinner>

<ngx-spinner name="spinnerAmbilData" bdOpacity="1" bdColor="rgba(255, 165, 0, 0.78)" size="large" color="#ffffff"
    align="center" type="ball-running-dots" [fullScreen]="true">
    <p style="color: #ffffff; text-align: center"><br><br>Mengambil Data...</p>
</ngx-spinner>

<ngx-spinner name="spinnerSimpanData" bdOpacity="1" bdColor="rgba(255, 165, 0, 0.78)" size="large" color="#ffffff"
    align="center" type="ball-running-dots" [fullScreen]="true">
    <p style="color: #ffffff; text-align: center"><br><br>Simpan Data...</p>
</ngx-spinner>

<ngx-spinner name="spinnerHapusData" bdOpacity="1" bdColor="rgba(255, 165, 0, 0.78)" size="large" color="#ffffff"
    align="center" type="ball-running-dots" [fullScreen]="true">
    <p style="color: #ffffff; text-align: center"><br><br>Hapus Data...</p>
</ngx-spinner>

<ngx-spinner name="spinnerSuntingData" bdOpacity="1" bdColor="rgba(255, 165, 0, 0.78)" size="large" color="#ffffff"
    align="center" type="ball-running-dots" [fullScreen]="true">
    <p style="color: #ffffff; text-align: center"><br><br>Sunting Data...</p>
</ngx-spinner>

<ngx-spinner name="spinnerCariData" bdOpacity="1" bdColor="rgba(255, 165, 0, 0.78)" size="large" color="#ffffff"
    align="center" type="ball-running-dots" [fullScreen]="true">
    <p style="color: #ffffff; text-align: center"><br><br>Mencari Data...</p>
</ngx-spinner>

<ngx-spinner name="spinnerTransferSpjBku" bdOpacity="1" bdColor="rgba(255, 165, 0, 0.78)" size="large" color="#ffffff"
    align="center" type="ball-running-dots" [fullScreen]="true">
    <p style="color: #ffffff; text-align: center"><br><br>Transfer SPJ BKU...</p>
</ngx-spinner>

<ngx-spinner name="spinnerProsesCreateBilling" bdOpacity="1" bdColor="rgba(255, 165, 0, 0.78)" size="large"
    color="#ffffff" align="center" type="ball-running-dots" [fullScreen]="true">
    <p style="color: #ffffff; text-align: center"><br><br>Proses Permohonan Billing...</p>
</ngx-spinner>

<ngx-spinner name="spinnerProsesReinquiryBilling" bdOpacity="1" bdColor="rgba(255, 165, 0, 0.78)" size="large"
    color="#ffffff" align="center" type="ball-running-dots" [fullScreen]="true">
    <p style="color: #ffffff; text-align: center"><br><br>Proses Re-Inquiry Billing...</p>
</ngx-spinner>

<ngx-spinner name="spinnerProsesInquiryBilling" bdOpacity="1" bdColor="rgba(255, 165, 0, 0.78)" size="large"
    color="#ffffff" align="center" type="ball-running-dots" [fullScreen]="true">
    <p style="color: #ffffff; text-align: center"><br><br>Proses Inquiry Billing...</p>
</ngx-spinner>

<ngx-spinner name="spinnerProsesPaymentBilling" bdOpacity="1" bdColor="rgba(255, 165, 0, 0.78)" size="large"
    color="#ffffff" align="center" type="ball-running-dots" [fullScreen]="true">
    <p style="color: #ffffff; text-align: center"><br><br>Proses Pembayaran Billing...</p>
</ngx-spinner>


<ngx-spinner name="spinnerProsesBatal" bdOpacity="1" bdColor="rgba(255, 165, 0, 0.78)" size="large" color="#ffffff"
    align="center" type="ball-running-dots" [fullScreen]="true">
    <p style="color: #ffffff; text-align: center"><br><br>Proses Pembatalan...</p>
</ngx-spinner>

<ngx-spinner name="spinnerProsesPersetujuan" bdOpacity="1" bdColor="rgba(255, 165, 0, 0.78)" size="large"
    color="#ffffff" align="center" type="ball-running-dots" [fullScreen]="true">
    <p style="color: #ffffff; text-align: center"><br><br>Proses Persetujuan...</p>
</ngx-spinner>

<ngx-spinner name="spinnerUpload" bdOpacity="1" bdColor="rgba(255, 165, 0, 0.78)" size="large" color="#ffffff"
    align="center" type="ball-running-dots" [fullScreen]="true">
    <p style="color: #ffffff; text-align: center"><br><br>Proses Upload...</p>
</ngx-spinner>

<ngx-spinner name="spinnerProsesCekStatusBilling" bdOpacity="1" bdColor="rgba(255, 165, 0, 0.78)" size="large"
    color="#ffffff" align="center" type="ball-running-dots" [fullScreen]="true">
    <p style="color: #ffffff; text-align: center"><br><br>Proses Cek Status Billing...</p>
</ngx-spinner>


<ngx-spinner name="spinnerProsesMigrasiRkas" bdOpacity="1" bdColor="rgba(255, 165, 0, 0.78)" size="large"
    color="#ffffff" align="center" type="ball-running-dots" [fullScreen]="true">
    <p style="color: #ffffff; text-align: center"><br><br>Proses Migrasi RKAS...</p>
</ngx-spinner>